import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=09068745&"
import script from "./my-profile.vue?vue&type=script&lang=js&"
export * from "./my-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09068745')) {
      api.createRecord('09068745', component.options)
    } else {
      api.reload('09068745', component.options)
    }
    module.hot.accept("./my-profile.vue?vue&type=template&id=09068745&", function () {
      api.rerender('09068745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/my-profile/my-profile.vue"
export default component.exports